import { useUserSheet } from "../userSheetContext";

import {
  Column,
  ErrorText,
  LoadingIndicator,
  OtherCandidaciesTable,
} from "@/components";

import { useGetOtherCandidacies } from "@/hooks/queries/useGetOtherCandidacies";
import { cn } from "@/lib/utils";

export const OtherCandidaciesTab = () => {
  /* Context */
  const { candidacyId, contentPaddingClassName, workerId } = useUserSheet();

  /* Database CRUD Operations */
  // Read
  const talentId = workerId;
  const otherCandidaciesQuery = useGetOtherCandidacies({
    candidacyId,
    talentId,
  });

  /* Render */
  const render = () => {
    if (!talentId) {
      return (
        <Column className={cn("py-7", contentPaddingClassName)}>
          <OtherCandidaciesTable isDashboardStyle otherCandidacies={[]} />
        </Column>
      );
    }
    if (otherCandidaciesQuery.isPending) {
      return (
        <Column className={cn("mt-6", contentPaddingClassName)}>
          <LoadingIndicator variant="medium" />
        </Column>
      );
    }
    if (otherCandidaciesQuery.isError) {
      return (
        <Column className={cn("mt-6", contentPaddingClassName)}>
          <ErrorText errorMessage="Error retrieving other candidacies." />
        </Column>
      );
    }

    return (
      <Column className={cn("py-7", contentPaddingClassName)}>
        <OtherCandidaciesTable
          isDashboardStyle
          otherCandidacies={otherCandidaciesQuery.data}
        />
      </Column>
    );
  };

  return render();
};
